import {BaseCreateItemStore} from "@leap4/frontend";
import {IGroup} from "../../interfaces/IGroup";

export class CreateGroupStore extends BaseCreateItemStore<IGroup>{
    entityName: string ="Group";
}